import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useSnackbar } from "notistack";
import { useEffect } from "react";

import InformationalVideoModalWrapper from "@/common/components/InformationalVideoModal/InformationalVideoModalWrapper";
import { Page } from "@/common/components/InformationalVideoModal/types";
import { MapView } from "@/common/components/MapLandingPage/MapView";
import { RootState, useSelector } from "@/store";


const MapLandingPage: React.FC = () => {
    const { alerts } = useSelector((state: RootState) => state.alerts);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        alerts.forEach((alert) => {
            const AlertLanding = (
                <Alert key={alert.index} severity={alert.severity}>
                    {alert.message}
                </Alert>
            );

            enqueueSnackbar(AlertLanding, {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                },
                autoHideDuration: 8000,
                key: alert.message,
                persist: false,
                preventDuplicate: true,
                variant: alert.severity,
            });
        });
    }, [alerts]);

    return (
        <Box>
            <InformationalVideoModalWrapper page={Page.VmsMap}/>
            <MapView />
        </Box>
    );
};
export default MapLandingPage;
